export default "__VITE_ASSET__tePJDeQh__"